import React from "react";

export const TermsV1_0: React.FC = () => {
  return (
    <div className="p-4 sm:p-6 space-y-8 text-gray-700 leading-relaxed">
      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">1 – Introdução</h2>
        <div className="space-y-3">
          <p>
            A INTERLACED é uma plataforma social de titularidade da empresa VIBE CODING LTDA, inscrita no CNPJ sob o nº 62.467.317/0001-90, com sede em São Paulo – SP, Brasil, denominada simplesmente "INTERLACED".
          </p>
          <p>
            A plataforma foi desenvolvida com o objetivo de facilitar a interação entre usuários maiores de 18 (dezoito) anos, por meio de funcionalidades que promovem conexões interpessoais baseadas em afinidade, interesses comuns e objetivos previamente definidos, sem garantir a efetividade ou continuidade dessas interações.
          </p>
          <p>
            A INTERLACED não realiza intermediação comercial, financeira ou contratual entre os usuários e não se responsabiliza por quaisquer perdas, danos ou prejuízos decorrentes de relações estabelecidas entre eles, ainda que iniciadas em seu ambiente digital.
          </p>
          <p>
            Ao acessar, aceitar e utilizar a INTERLACED, o usuário declara expressamente que leu, compreendeu e concorda integralmente com os presentes Termos de Uso, bem como com a Política de Privacidade, as Diretrizes de Uso da Plataforma e as Políticas Adicionais de Cookies, comprometendo-se a respeitar todas as disposições legais, éticas e técnicas aqui estabelecidas.
          </p>
          <p>
            A INTERLACED se reserva o direito de alterar, modificar ou atualizar estes Termos de Uso a qualquer tempo. As alterações entrarão em vigor na data de sua publicação na plataforma.
          </p>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">2 – Partes</h2>
        <div className="space-y-2">
          <p><strong>PLATAFORMA:</strong> INTERLACED, plataforma social online.</p>
          <p><strong>USUÁRIO:</strong> toda pessoa física, maior de 18 anos, que acesse ou utilize a plataforma e concorde com os Termos de Uso.</p>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">3 – Critérios de Elegibilidade</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>O cadastro é permitido apenas para pessoas físicas maiores de 18 anos, com plena capacidade civil.</li>
          <li>É proibido o uso por pessoas jurídicas.</li>
          <li>O usuário não pode ter condenação por crimes sexuais ou de violência, nem medida protetiva vigente.</li>
          <li>O uso comercial é proibido.</li>
          <li>É necessário residir no Brasil.</li>
          <li>A conta é pessoal, individual e intransferível.</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">4 – Suas Responsabilidades</h2>
        <div className="space-y-3">
          <p>
            O usuário deve cumprir integralmente os Termos, obedecer à legislação vigente, utilizar a versão atualizada da plataforma, adotar medidas de segurança e agir com responsabilidade.
          </p>
          <p className="font-semibold">É proibido:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Falsificar identidade</li>
            <li>Usar a plataforma para fins ilegais</li>
            <li>Assediar outros usuários</li>
            <li>Divulgar informações privadas</li>
            <li>Usar bots</li>
            <li>Explorar vulnerabilidades</li>
            <li>Realizar atividades comerciais sem autorização</li>
          </ul>
          <p>
            O uso não autorizado das APIs ou de dados pessoais poderá gerar sanções civis e criminais.
          </p>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">5 – Interações entre os Usuários</h2>
        <div className="space-y-3">
          <p>Cada usuário é responsável por suas interações e publicações.</p>
          <p>A Interlaced recomenda cautela ao compartilhar informações pessoais.</p>
          <p>A empresa não se responsabiliza por conflitos entre usuários.</p>
          <p>É proibido qualquer tipo de assédio, perseguição, discurso de ódio ou violação de privacidade.</p>
          <p>Denúncias de comportamento inadequado podem ser feitas pelos canais oficiais da plataforma.</p>
          <p>A violação das regras pode resultar em advertência, suspensão ou exclusão definitiva da conta.</p>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">6 – Verificação de Antecedentes Criminais</h2>
        <p>
          A Interlaced não realiza verificações de antecedentes criminais e não se responsabiliza por atos ilícitos de usuários.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">7 – Conteúdo Proibido</h2>
        <div className="space-y-3">
          <p className="font-semibold">É proibido compartilhar:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Conteúdos envolvendo menores de 18 anos</li>
            <li>Conteúdos violentos, pornográficos, discriminatórios ou ilegais</li>
            <li>Material protegido por direitos autorais sem autorização</li>
            <li>Discurso de ódio, apologia à violência, fake news, golpes, pirâmides, ou links externos comerciais</li>
            <li>Atividades que burlem a moderação ou os mecanismos de segurança da plataforma</li>
          </ul>
          <p>
            O descumprimento pode resultar na exclusão imediata da conta e comunicação às autoridades.
          </p>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">8 – Seu Conteúdo</h2>
        <div className="space-y-3">
          <p>O usuário é totalmente responsável por tudo o que publica.</p>
          <p>Não deve divulgar dados pessoais, bancários ou sensíveis.</p>
          <p>O descumprimento das regras pode levar à exclusão da conta sem reembolso.</p>
          <p>O usuário continua responsável por seus conteúdos mesmo após excluir a conta.</p>
        </div>

        <h3 className="text-lg font-semibold mt-6 mb-3 text-gray-800">8.1 – Conteúdo da Interlaced</h3>
        <div className="space-y-3">
          <p>Todo material visual, textual, logotipos e design da Interlaced são propriedade da VIBE CODING LTDA.</p>
          <p>É proibida qualquer reprodução, distribuição ou modificação sem autorização.</p>
          <p>O uso indevido gera responsabilização civil e criminal.</p>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">9 – Conteúdo Inadequado, Conduta Inapropriada e Denúncias</h2>
        <div className="space-y-3">
          <p>A Interlaced proíbe qualquer conteúdo ofensivo, discriminatório ou que atente contra direitos fundamentais.</p>
          <p>Mensagens privadas podem ser analisadas para garantir a segurança da comunidade.</p>
          <p>Usuários devem denunciar comportamentos abusivos.</p>
          <p>A plataforma pode aplicar sanções administrativas, civis ou criminais conforme a gravidade da infração.</p>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">10 – Privacidade</h2>
        <div className="space-y-3">
          <p>Os dados pessoais são tratados conforme a LGPD (Lei nº 13.709/2018).</p>
          <p>O usuário deve ler a Política de Privacidade disponível na plataforma para entender como seus dados são utilizados e protegidos.</p>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">11 – Direitos Concedidos pela Interlaced</h2>
        <div className="space-y-3">
          <p>O usuário recebe uma licença pessoal, mundial, não exclusiva e revogável para usar os serviços conforme estes Termos.</p>
          <p>O descumprimento resulta em suspensão imediata da licença.</p>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">12 – Licença Concedida pelo Usuário à Interlaced</h2>
        <div className="space-y-3">
          <p>O usuário concede à Interlaced uma licença mundial, perpétua e isenta de royalties para usar, hospedar, copiar e distribuir o conteúdo postado na plataforma.</p>
          <p>A Interlaced pode agir em nome do usuário para proteger o conteúdo contra uso indevido por terceiros.</p>
          <p>A plataforma pode veicular publicidade como forma de contraprestação pelo uso gratuito dos serviços.</p>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">13 – Assinaturas e Cancelamentos</h2>
        <div className="space-y-3">
          <p>A assinatura é renovada automaticamente até o cancelamento pelo usuário.</p>
          <p>Não há fidelidade contratual.</p>
          <p>Os preços e promoções são aplicados apenas no Brasil.</p>
          <p>A Interlaced pode alterar valores, suspender promoções e recusar serviços a usuários que violem os Termos.</p>
        </div>

        <h3 className="text-lg font-semibold mt-6 mb-3 text-gray-800">13.1 – Pagamentos</h3>
        <div className="space-y-3">
          <p>As compras são processadas conforme o método de pagamento informado.</p>
          <p>A falta de pagamento pode levar ao encerramento da conta.</p>
          <p>O usuário deve cancelar assinaturas manualmente para evitar cobranças futuras.</p>
        </div>

        <h3 className="text-lg font-semibold mt-6 mb-3 text-gray-800">13.2 – Reembolsos</h3>
        <div className="space-y-3">
          <p>Por regra, compras não são reembolsadas.</p>
          <p>Aplica-se o direito de arrependimento de 7 dias previsto no Código de Defesa do Consumidor.</p>
          <p>Em caso de falecimento, o herdeiro legal pode solicitar o cancelamento e reembolso.</p>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">14 – Cancelamento e Exclusão de Contas</h2>
        <div className="space-y-3">
          <p>O usuário pode excluir sua conta a qualquer momento.</p>
          <p>A Interlaced pode suspender ou encerrar contas que violem os Termos sem aviso prévio.</p>
          <p>Dados e informações serão tratados conforme a Política de Privacidade.</p>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">15 – Ressalvas sobre os Serviços</h2>
        <div className="space-y-3">
          <p>A plataforma é oferecida "no estado em que se encontra".</p>
          <p>A Interlaced não garante funcionamento contínuo ou resultados específicos.</p>
          <p>Não se responsabiliza por perdas indiretas ou danos causados por falhas técnicas ou ataques.</p>
          <p>Compromete-se, no entanto, a corrigir problemas e oferecer suporte.</p>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">16 – Direitos Autorais</h2>
        <div className="space-y-3">
          <p>A Interlaced respeita direitos de propriedade intelectual.</p>
          <p>Em caso de infração, o titular deve enviar uma notificação formal para análise e remoção do conteúdo.</p>
          <p>Reincidência pode resultar na exclusão da conta.</p>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">17 – Anúncios e Conteúdo de Terceiros</h2>
        <div className="space-y-3">
          <p>A Interlaced pode exibir anúncios de terceiros, que são de responsabilidade exclusiva dos anunciantes.</p>
          <p>Links externos não são controlados pela plataforma.</p>
          <p>Qualquer relação comercial entre o usuário e o anunciante é independente da Interlaced.</p>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">18 – Limitação de Responsabilidade</h2>
        <div className="space-y-3">
          <p className="font-semibold">A responsabilidade da Interlaced está limitada a R$ 500,00 por usuário.</p>
          <p>A empresa não responde por perdas indiretas, acessos não autorizados ou conteúdos de terceiros.</p>
          <p>O prazo para reclamações é de 90 dias após o fato.</p>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">19 – Legislação Aplicável</h2>
        <p>O contrato é regido exclusivamente pela legislação brasileira.</p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">20 – Foro de Eleição</h2>
        <p>Fica eleito o foro da Comarca de São Paulo – SP como competente para resolver quaisquer disputas.</p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">21 – Indenização</h2>
        <p>O usuário concorda em indenizar a Interlaced por danos decorrentes de suas ações, conteúdos ou violações destes Termos.</p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">22 – Aceitação dos Termos de Uso</h2>
        <div className="space-y-3">
          <p>Ao utilizar a plataforma, o usuário confirma que leu e aceitou integralmente estes Termos e a Política de Privacidade.</p>
          <p>Estes Termos substituem quaisquer acordos anteriores.</p>
          <p>Caso não concorde, o usuário deve cessar o uso imediatamente.</p>
          <p>A conta é pessoal e intransferível.</p>
          <p>A Interlaced pode ceder seus direitos e obrigações livremente.</p>
          <p>O contrato não cria vínculo empregatício, de sociedade ou representação entre as partes.</p>
        </div>
      </section>

      <div className="mt-8 pt-4 border-t border-gray-200">
        <p className="text-sm text-gray-500">
          Versão 1.0 — 20 de Janeiro de 2025
        </p>
      </div>
    </div>
  );
};
